import { Map, List } from 'immutable'
import {
  TEXT_FORMAT_PLAIN_TEXT,
  TEXT_FORMAT_BASIC_HTML,
  TEXT_FORMAT_RESTRICTED_HTML,
  TEXT_FORMAT_FULL_HTML,
  TEXT_FORMAT_MARKDOWN,
} from './constants'

export default List([
  Map({ label: 'Please select an input format', value: '' }),
  Map({ label: 'Plain text', value: TEXT_FORMAT_PLAIN_TEXT }),
  Map({ label: 'Basic html', value: TEXT_FORMAT_BASIC_HTML }),
  Map({ label: 'Restricted html', value: TEXT_FORMAT_RESTRICTED_HTML }),
  Map({ label: 'Full html', value: TEXT_FORMAT_FULL_HTML }),
  Map({ label: 'Markdown', value: TEXT_FORMAT_MARKDOWN }),
])
